import { useEffect } from 'react';

const MESSAGE = 'You have unsaved changes. Leave without saving?';

let dirtyCount = 0;

const onBeforeUnload = (e: BeforeUnloadEvent) => {
  e.preventDefault();
};

const onClick = (e: MouseEvent) => {
  const target = e.target as HTMLElement | null;
  const anchor = target?.closest?.('a[href]');
  if (!anchor) return;
  const href = anchor.getAttribute('href') ?? '';
  if (!href.startsWith('/')) return;
  if (anchor.getAttribute('target') === '_blank') return;
  if (!window.confirm(MESSAGE)) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
};

export function useUnsavedChangesGuard(dirty: boolean) {
  useEffect(() => {
    if (!dirty) return;
    dirtyCount += 1;
    if (dirtyCount === 1) {
      window.addEventListener('beforeunload', onBeforeUnload);
      document.addEventListener('click', onClick, true);
    }
    return () => {
      dirtyCount -= 1;
      if (dirtyCount === 0) {
        window.removeEventListener('beforeunload', onBeforeUnload);
        document.removeEventListener('click', onClick, true);
      }
    };
  }, [dirty]);
}
